module.exports = __webpack_public_path__ + "img/banner.43ff0a62.jpg";